<div class="settings-categories">
  @if (categories().length > 0 || isLoading()) {
    <div class="header">
      <span class="header__spacer"></span>
      <button
        mat-button
        color="primary"
        class="header__add-category-btn"
        (click)="openAddCategory()"
      >
        <span>{{ 'shop-settings.categories.addButton' | translate }}</span>
        <mat-icon class="add-icon">add</mat-icon>
      </button>
    </div>

    <div class="settings-categories__part">
      <div class="table-wrapper">
        <table
          mat-table
          [dataSource]="isLoading() ? skeletonRows() : categories()"
          class="full-width-table"
          matSort
        >
          @for (column of columnsConfig; track column.name) {
            <ng-container [matColumnDef]="column.name">
              <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
                {{ column.label | translate }}
              </th>

              <td mat-cell *matCellDef="let category">
                @if (isLoading()) {
                  @if (column.kind === 'actions') {
                    <div class="skeleton skeleton--icon"></div>
                  } @else {
                    <div
                      class="skeleton skeleton--text"
                      [class.skeleton--short]="column.kind === 'numberProducts'"
                    ></div>
                  }
                } @else {
                  @if (column.kind === 'numberProducts') {
                    <button class="products-count-btn" mat-button>
                      {{ category.itemsAmount }}
                    </button>
                  } @else if (column.kind === 'actions') {
                    <button
                      class="cell"
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      #menuTrigger="matMenuTrigger"
                    >
                      <mat-icon [class.menu-open]="menuTrigger.menuOpen">more_vert</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu" class="categories-menu">
                      <button mat-menu-item (click)="onEditCategory(category)">
                        <app-icon class="icon" [icon]="IconName.PENCIL" />
                        {{ 'shop-settings.categories.actions.edit' | translate }}
                      </button>

                      <button mat-menu-item (click)="onDeleteCategory(category)">
                        <app-icon class="icon" [icon]="IconName.TRASH" />
                        {{ 'shop-settings.categories.actions.delete' | translate }}
                      </button>
                    </mat-menu>
                  } @else {
                    @if (column.name === 'visibility') {
                      {{ category.visibility.toString() | titlecase }}
                    } @else {
                      {{ category[column.name] }}
                    }
                  }
                }
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>

    <div class="settings-categories__footer footer">
      @if (!isLoading() && settingCategoriesPagination().totalItems > 0) {
        <app-table-pagination
          [pagination]="settingCategoriesPagination()"
          (pageChange)="handlePageChange($event)"
          (pageSizeChange)="handlePageSizeChange($event)"
        />
      }
    </div>
  } @else {
    <div class="empty-categories">
      <h2 class="empty-categories__title">
        {{ 'shop-settings.categories.emptyState.title' | translate }}
      </h2>

      <span class="empty-categories__description">
        {{ 'shop-settings.categories.emptyState.description' | translate }}
      </span>

      <button
        mat-button
        color="primary"
        class="header__add-category-btn"
        (click)="openAddCategory()"
      >
        <span>{{ 'shop-settings.categories.addButton' | translate }}</span>
        <mat-icon class="add-icon">add</mat-icon>
      </button>
    </div>
  }
</div>
